module.exports = __webpack_public_path__ + "static/media/kuro-security-ill.06d0cedf.svg";